<template>
  <v-avatar
    v-if="user?.image"
    :class="{ focused }"
    :size="$props.size"
  >
    <img
      referrerpolicy="no-referrer"
      :src="user?.image"
    >
  </v-avatar>

  <v-avatar
    v-else
    :class="{ focused }"
    color="secondary"
    :size="$props.size"
  >
    <span
      v-if="user?.name"
      :style="{ fontSize: `${(size || 48) / 48 * 1.25}rem` }"
    >{{ getInitials(user?.name) }}</span>

    <vi-icon
      v-else
      icon="mdi:account"
      :size="size ? size * 0.75 : ''"
    />
  </v-avatar>
</template>

<script setup lang="ts">
defineProps<{
  user?: {
    name?: string
    image?: string
  }
  size?: number
  focused?: boolean
}>();

const getInitials = (fullName: string) => fullName.split(' ')
  .slice(0, 2)
  .map(word => word[0])
  .join('');
</script>

<style scoped lang="scss">
@import "~/assets/styles/variables";

.v-avatar > img {
  width: 100%;
}

.v-avatar {
  box-shadow: 0 0 0 0px $primary;
  transition: box-shadow 0.1s ease-in-out;
}

.focused {
  box-shadow: 0 0 0 3px $primary;
}
</style>
